module.exports = __webpack_public_path__ + "static/img/6bac.0901d6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/6bac.jpg
// module id = 2GKA
// module chunks = 1